import { render, staticRenderFns } from "./TplComplexTable.vue?vue&type=template&id=15dba108&scoped=true&"
import script from "./TplComplexTable.vue?vue&type=script&lang=js&"
export * from "./TplComplexTable.vue?vue&type=script&lang=js&"
import style0 from "./TplComplexTable.vue?vue&type=style&index=0&id=15dba108&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dba108",
  null
  
)

export default component.exports